import React from "react";

// importing components
import DividerComponent from "../../components/divider-component/divider-component";
import VerticalDividerComponent from "../../components/vertical-divider-component/vertical-divider-component";

// importing styles
import "./tag-line-section-styles.scss";

const TagLineSection = () => {
	return (
		<section className="tag-line-section">
			<div className="tag-line-content-wrapper">
				<DividerComponent />
				<h3 className="tag-line-heading">
					Passionate about <br />
					creating exceptional <br />
					experiences!
				</h3>
				<VerticalDividerComponent
					imgSrc={require("../../assets/vertical-divider.png")}
				/>
			</div>
		</section>
	);
};

export default TagLineSection;
